<template>
  <v-card v-if="canShow" class="mb-6">
    <v-card-title>
      {{ dashboardTitle }}
      <v-spacer />
      <span v-if="dashboard && dashboard.cajaMensual" class="subtitle-2 grey--text">
        {{ formatMonth(dashboard.cajaMensual.fecha) }}
      </span>
    </v-card-title>

    <v-card-text v-if="loading">
      <v-progress-linear indeterminate />
    </v-card-text>

    <v-card-text v-else-if="error">
      <v-alert dense type="error">{{ error }}</v-alert>
    </v-card-text>

    <v-card-text v-else-if="dashboard">
      <v-row>
        <v-col cols="12" md="4">
          <dashboard-card title="Objetivo Total" symbol="$" :value="dashboard.objetivoTotal" />
        </v-col>
        <v-col cols="12" md="4">
          <dashboard-card title="Total Recaudado" symbol="$" :value="dashboard.totalRecaudado" />
        </v-col>
        <v-col cols="12" md="4">
          <dashboard-card title="Cumplimiento" :value="formatPercent(dashboard.cumplimiento)" is-string />
        </v-col>
      </v-row>

      <div class="chart-wrap mt-4">
        <agencia-objetivo-dashboard-chart :items="paginatedCarteras" />
      </div>

      <div v-if="totalPages > 1" class="dashboard-pagination d-flex justify-center">
        <v-pagination
            v-model="page"
            :length="totalPages"
            :total-visible="7"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import AgenciaObjetivoProvider from "@/modules/cobrox/providers/AgenciaObjetivoProvider";
import DashboardCard from "@/modules/cobrox/components/DashboardCard/DashboardCard";
import AgenciaObjetivoDashboardChart from "./AgenciaObjetivoDashboardChart";

const parseBackendDate = value => {
  const raw = String(value || '')
  return /^-?\d+$/.test(raw) ? Number(raw) : value
}
const ITEMS_PER_PAGE = 7

export default {
  name: "AgenciaObjetivoDashboard",
  components: {AgenciaObjetivoDashboardChart, DashboardCard},
  props: {
    agenciaId: {type: String, default: null},
    cajaMensualId: {type: String, default: null}
  },
  data() {
    return {
      dashboard: null,
      loading: false,
      error: null,
      page: 1
    }
  },
  computed: {
    canShow() {
      return this.$store.getters.hasPermission('AGENCIAOBJETIVO_DASHBOARD') ||
          this.$store.getters.hasPermission('AGENCIAOBJETIVO_IMPORT') ||
          this.$store.getters.hasPermission('AGENCIAOBJETIVO_ADMIN_DASHBOARD')
    },
    dashboardTitle() {
      return this.dashboard && this.dashboard.titulo ? this.dashboard.titulo : 'Objetivos mensuales'
    },
    sortedCarteras() {
      const carteras = this.dashboard && this.dashboard.carteras ? this.dashboard.carteras : []
      return [...carteras].sort((a, b) =>
          (b.objetivo - a.objetivo) ||
          (b.recaudado - a.recaudado) ||
          a.nombre.localeCompare(b.nombre)
      )
    },
    totalPages() {
      return Math.ceil(this.sortedCarteras.length / ITEMS_PER_PAGE)
    },
    paginatedCarteras() {
      const from = (this.page - 1) * ITEMS_PER_PAGE
      return this.sortedCarteras.slice(from, from + ITEMS_PER_PAGE)
    }
  },
  watch: {
    agenciaId() {
      if (this.canShow) this.fetchDashboard()
    },
    cajaMensualId() {
      if (this.canShow) this.fetchDashboard()
    },
    totalPages(total) {
      if (this.page > total) this.page = total || 1
    }
  },
  created() {
    if (this.canShow) this.fetchDashboard()
  },
  methods: {
    fetchDashboard() {
      this.loading = true
      AgenciaObjetivoProvider.dashboardObjetivosAgencia(this.agenciaId, this.cajaMensualId)
          .then(r => {
            this.dashboard = r.data.dashboardObjetivosAgencia
            this.page = 1
          })
          .catch(e => {
            this.error = e.message
          })
          .finally(() => {
            this.loading = false
          })
    },
    formatMonth(value) {
      return dayjs(parseBackendDate(value)).format('MM/YYYY')
    },
    formatPercent(value) {
      return Number(value || 0).toLocaleString('es-AR', {maximumFractionDigits: 2}) + '%'
    }
  }
}
</script>

<style scoped>
.chart-wrap {
  height: 360px;
}

.dashboard-pagination {
  margin-top: 32px;
}
</style>
